<template>
<!-- 视力报告-数据展示页面 -->
    <div class="school_page">
        <div class="content">
            <div class="school_top">
                <!-- 年级下拉 -->
                <div class="select_box">
                    <div class="select">
                        <p class="grade" @click.stop="funshowOptions">{{ gradeId }}</p>
                        <ul v-show="showOptions">
                            <li v-for="item in gradeList" :key="item.index" @click.stop="choose(item.value)"><a href="javascript:;">{{item.value}}</a></li>
                        </ul>
                    </div>

                <!-- 班级下拉 -->
                    <div v-if="gradeId!='年级'">
                        <p class="grade class" @click.stop="funshowClassOptions">{{ classId }}</p>
                        <ul v-show="showClassOptions">
                            <li v-for="item in classList" :key="item.index" @click.stop="chooseClass(item.value)"><a href="javascript:;">{{item.value}}</a></li>
                        </ul>
                    </div>
                </div>

                <!-- 分割线 -->
                <!-- <div class="dividing_line">|</div> -->
                <div class="select_time">
                    <!-- 开始时间 -->
                    <span class="time">开始时间：{{time}}</span>
                    <span class="calendar_icon"><img @click="fun_calendar" src="../../assets/icon-calendar@2x.png"></span>
                </div>
                <div class="select_time time_end">
                    <!-- 结束时间 -->
                    <span class="time" style="margin-left: 10px">结束时间：{{timeEnd}}</span>
                    <span class="calendar_icon"><img @click="funTimeEnd" src="../../assets/icon-calendar@2x.png"></span>
                </div>

            </div>

            <div>
                <!-- 使用人数 -->
                <span class="circle" style="background: #3f8ed4"></span>
                <p class="title">{{gradeTitle}}设备使用人数</p>
                <!-- 柱状图 -->
                <div>
                    <div id="people" style="width: 100%; height:280px;"></div>
                </div>
            </div>

          <div>
            <!-- 使用人数 -->
            <span class="circle" style="background: #3f8ed4"></span>
            <p class="title">{{gradeTitle}}设备持有人数</p>
            <!-- 柱状图 -->
            <div>
              <div id="grade" style="width: 100%; height:280px;"></div>
            </div>
          </div>

            <div>
                <!-- 使用时间 -->
                <span class="circle" style="background: #d65746"></span>
                <p class="title">{{gradeTitle}}设备使用时间(min)</p>
                <!-- 柱状图 -->
                <div>
                    <div id="use_time" style="width: 100%; height:280px;"></div>
                </div>
            </div>

            <div>
                <!-- 使用次数 -->
                <span class="circle" style="background: #eac645"></span>
                <p class="title">{{gradeTitle}}设备使用次数</p>
                <!-- 柱状图 -->
                <div>
                    <div id="use_number" style="width: 100%; height:280px;"></div>
                </div>
            </div>

            <div class="progressbar">
                <p class="title titleF">
                    <span class="circle" style="background: #7cd393"></span>
                    {{rateTitle}}设备使用率</p>

                <!-- 饼图 -->
                <!-- 全校使用率 -->
                <van-circle
                calss="pic"
                v-model="currentRate"
                :rate="num"
                :speed="100"
                layer-color="#e6e6e6"
                :text="progressbar"
                :stroke-width="100"
                :size="150"
                color="#7cd393"
                />

                <div class=tips_box>
                    <div class="tips">{{num}}%</div>
                </div>
            </div>

            <div class="result">{{rateTitle}}总人数{{sum}}</div>

        </div>

        <!-- 日历弹出 -->
        <van-popup v-model="show" :style="{ height: '40%' }">
            <van-datetime-picker
            v-model="currentDate"
            type="date"
            :min-date="minDate"
            :max-date="maxDate"
            :formatter="formatter"
            @confirm="timeSave"
            @cancel="onCancel"
            />
        </van-popup>

        <van-popup v-model="showTimeEnd" :style="{ height: '40%' }">
            <!-- 结束时间 -->
            <van-datetime-picker
            v-model="currentDate"
            type="date"
            :min-date="minTimeEnd"
            :max-date="maxDate"
            :formatter="formatter"
            @confirm="timeFunEnd"
            @cancel="onCancel"
            />
        </van-popup>

    </div>
</template>

<script>
import Vue from 'vue';
import { DatetimePicker } from 'vant';
import { Popup } from 'vant';
import { Circle } from 'vant';
import { Dialog } from 'vant';

Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Circle);

export default {
    props: {

    },
    data() {
        return {
            showOptions: false, // 年级
            showClassOptions: false,    //班级
            show: false,    //选择开始时间
            showTimeEnd: false,     // 选择结束时间
            currentDate: new Date(),
            minDate: new Date(1900,0,1),

            minTimeEnd: new Date(1900,0,1),

            maxDate: new Date(),
            // 选择年级
            gradeId: '',
            gradeList: [
                {
                    key: -1, value: "年级"
                },
                {
                    key: 1, value: "一年级"
                },
                {
                    key: 2, value: "二年级"
                },
                {
                    key: 3, value: "三年级"
                },
                {
                    key: 4, value: "四年级"
                },
                {
                    key: 5, value: "五年级"
                },
                {
                    key: 6, value: "六年级"
                }
            ],
            // 选择班级
            classId: '',
            classList: [
                {
                    key: -1, value: "班级"
                }
            ],
            time: new Date(),   // 显示开始时间
            timeEnd: new Date(), // 显示结束时间

            // 使用人数echarts
            people_option: {

                color: ['#3f8ed4'],
                tooltip : {
                    trigger: 'axis',
                    axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                        type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    top: '40',
                    left: '0',
                    right: '0',
                    bottom: '0',
                    containLabel: true
                },
                xAxis : [
                    {
                        type : 'category',
                        data : ['一年级', '二年级', '三年级', '四年级'],
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLabel:{
                            interval: 0,
                            textStyle:{
                                color:"#333",
                                fontSize: 14
                            },
                        },

                    }
                ],
                yAxis : [
                    {
                        type : 'value',
                        interval: 30,
                    }
                ],
                series : [
                    {
                        name:'使用人数',
                        type:'bar',
                        barWidth: '60%',
                        data:[],
                        label: {
                            show: true, //开启显示
                            position: 'top', //在上方显示
                            textStyle: { //数值样式
                                backgroundColor: '#3f8ed4',
                                // border-radius
                                borderRadius: 5,
                                padding: 4,
                                color: '#fff',
                                fontSize: 12,
                                fontWeight: 400
                            }
                        }
                    },
                ]
            },


          //设备持有人数
          grade_option: {

            color: ['#6188CA'],
            tooltip : {
              trigger: 'axis',
              axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            grid: {
              top: '40',
              left: '0',
              right: '0',
              bottom: '0',
              containLabel: true
            },
            xAxis : [
              {
                type : 'category',
                data : ['一年级', '二年级', '三年级', '四年级'],
                axisTick: {
                  alignWithLabel: true
                },
                axisLabel:{
                  interval: 0,
                  textStyle:{
                    color:"#333",
                    fontSize: 14
                  },
                },

              }
            ],
            yAxis : [
              {
                type : 'value',
                interval: 30,
              }
            ],
            series : [
              {
                name:'持有人数',
                type:'bar',
                barWidth: '60%',
                data:[],
                label: {
                  show: true, //开启显示
                  position: 'top', //在上方显示
                  textStyle: { //数值样式
                    backgroundColor: '#6188CA',
                    // border-radius
                    borderRadius: 5,
                    padding: 4,
                    color: '#fff',
                    fontSize: 12,
                    fontWeight: 400
                  }
                }
              },
            ]
          },




            // 使用时间echarts
            use_time_option: {
                color: ['#d65746'],
                tooltip : {
                    trigger: 'axis',
                    axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                        type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    top: '30',
                    left: '0',
                    right: '0',
                    bottom: '0',
                    containLabel: true
                },
                xAxis : [
                    {
                        type : 'category',
                        data : ['一年级', '二年级', '三年级', '四年级'],
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLabel:{
                            interval: 0,
                            textStyle:{
                                color:"#333",
                                fontSize: 14
                            },
                        },

                    }
                ],
                yAxis : [
                    {
                        type : 'value',
                        interval: 3000,
                    }
                ],
                series : [
                    {
                        name:'使用时间',
                        type:'bar',
                        barWidth: '60%',
                        data:[],
                        label: {
                            show: true, //开启显示
                            position: 'top', //在上方显示
                            textStyle: { //数值样式
                                backgroundColor: '#d65746',
                                // border-radius
                                borderRadius: 5,
                                padding: 4,
                                color: '#fff',
                                fontSize: 12,
                                fontWeight: 400
                            }
                        }
                    },
                ]
            },

            // 使用次数echarts
            use_number_option: {
                color: ['#eac645'],
                tooltip : {
                    trigger: 'axis',
                    axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                        type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    top: '30',
                    left: '0',
                    right: '0',
                    bottom: '0',
                    containLabel: true
                },
                xAxis : [
                    {
                        type : 'category',
                        data : ['一年级', '二年级', '三年级', '四年级'],
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLabel:{
                            interval: 0,
                            textStyle:{
                                color:"#333",
                                fontSize: 14
                            },
                        },

                    }
                ],
                yAxis : [
                    {
                        type : 'value',
                        interval: 200,
                    }
                ],
                series : [
                    {
                        name:'使用时间',
                        type:'bar',
                        barWidth: '60%',
                        data:[],
                        label: {
                            show: true, //开启显示
                            position: 'top', //在上方显示
                            textStyle: { //数值样式
                                backgroundColor: '#eac645',
                                // border-radius
                                borderRadius: 5,
                                padding: 4,
                                color: '#fff',
                                fontSize: 12,
                                fontWeight: 400
                            }
                        }
                    },
                ]
            },



            // 环形进度条
            currentRate: 80,    // 当前进度
            num: 0,    // 目标进度
            peopleNum: 0, // 使用人数

            gradeTitle: '各年级',
            rateTitle: '全校',

            sum: '',
            useSum: '',
        };
    },
    computed: {
        progressbar() {
            return `使用人数${this.peopleNum.toFixed(0)}`
        }
    },
    created() {
        this.gradeId = this.gradeList[0].value;
        this.classId = this.classList[0].value;

    },
    mounted() {
        this.time = this.time.getFullYear() + '-' + (this.time.getMonth() + 1) + '-' + this.time.getDate()
        this.timeEnd = this.timeEnd.getFullYear() + '-' + (this.timeEnd.getMonth() + 1) + '-' + this.timeEnd.getDate()

        let that = this
        document.addEventListener('click', function() {
            that.showOptions = false
            that.showClassOptions = false
        })
        this.getGradeData()
    },
    methods: {
        // 获取年级数据
        getGradeData() {
            this.axios.get('/weixin/student/getSchool', {
                params: {
                    cname: this.$route.params.cname,
                    ft: this.time,
                    et: this.timeEnd
                }
            })
            .then(res=>{
                if(!res.data.listmap) {
                    Dialog.alert({
                        message: res.data.error
                    }).then(() => {
                        this.$router.go(-1);
                    });
                    return false
                }

                let a = -1
                const sumArr = []
                const useSumArr = []
             //   this.gradeList.splice(res.data.listmap.size + 1)
                res.data.listmap.map(i=>{
                    a++
                    for(let e in i) {
                        if(e=='gradeNumber') {
                            this.people_option.series[0].data[a] = i[e]
                        }
                        if(e=='gradeTime'){
                            this.use_time_option.series[0].data[a] = i[e]
                        }
                        if(e=='gradeMany'){
                            this.use_number_option.series[0].data[a] = i[e]
                        }
                        if(e=='receiveNumber'){//receiveNumber
                           this.grade_option.series[0].data[a] = i[e]
                        }
                    }

                    return sumArr.push(Number(i.gradeAll)), useSumArr.push(Number(i.gradeNumber))
                })
                function getSum(total, num) {
                    return total + num;
                }
                this.sum = sumArr.reduce(getSum)
                this.peopleNum = useSumArr.reduce(getSum)

                if(this.sum && this.peopleNum) {
                    this.num =Math.round( (this.peopleNum / this.sum) * 100)
                }else {
                    this.num = 0
                }

                this.people_echarts()
                this.use_time_echarts()
                this.use_bumber_echarts()
                this.grade_echarts()
            })
        },

        // 获取班级数据
        getClassData() {
            const classArr = ['一年级', '二年级', '三年级', '四年级']
            const a = classArr.indexOf(this.gradeTitle) + 1
            const data = {
                gradeName: a,
                ft: this.time,
                et: this.timeEnd
            }
            this.axios.get('/weixin/student/getGrade', {
                params: data
            })
            .then(res=>{
                if(this.classList.length > 1) {
                    this.classList.splice(1)
                }
                res.data.listmap.map((item, index)=>{
                    return this.classList.push({
                        key: index + 1,
                        value: item.className
                    })
                })
                let n = -1
                const sumArr = []
                const useSumArr = []
                res.data.listmap.map(i => {
                    n++
                    this.people_option.xAxis[0].data[n] = i.className.slice(1,7)
                    this.use_time_option.xAxis[0].data[n] = i.className.slice(1,7)
                    this.use_number_option.xAxis[0].data[n] = i.className.slice(1,7)
                    this.grade_option.xAxis[0].data[n] = i.className.slice(1,7)

                    for(let e in i) {
                        if(e=='classNumber') {
                            this.people_option.series[0].data[n] = i[e]
                        }
                        if(e=='classTime'){
                            this.use_time_option.series[0].data[n] = i[e]
                        }
                        if(e=='classMany'){
                            this.use_number_option.series[0].data[n] = i[e]
                        }
                        if(e=='classReceiveNumber'){
                          this.grade_option.series[0].data[n] = i[e]
                        }
                    }

                    return sumArr.push(Number(i.classAll)), useSumArr.push(Number(i.classNumber))
                })
                this.people_option.xAxis[0].data.splice(n+1)
                this.use_time_option.xAxis[0].data.splice(n+1)
                this.use_number_option.xAxis[0].data.splice(n+1)
                this.grade_option.xAxis[0].data.splice(n+1)
                function getSum(total, num) {
                    return total + num;
                }
                this.sum = sumArr.reduce(getSum)
                this.peopleNum = useSumArr.reduce(getSum)
                if(this.sum && this.peopleNum) {
                    this.num =Math.round( (this.peopleNum / this.sum) * 100)
                }else {
                    this.num = 0
                }
                this.people_echarts()
                this.use_time_echarts()
                this.use_bumber_echarts()
                this.grade_echarts()
            })
        },


        funshowOptions() {
            this.showOptions = !this.showOptions
            this.showClassOptions = false
        },
        funshowClassOptions() {
            this.showClassOptions = !this.showClassOptions
            this.showOptions = false
        },
        // 选择年级
        choose(value) {
            this.showOptions = false
            this.classId = this.classList[0].value;
            if (value !== this.gradeId) {
                this.gradeId = value
            }

            if(value!='年级') {
                this.gradeTitle = value
                this.rateTitle = value
                this.getClassData()

            }else if(value=='年级'){
                this.gradeTitle = '各年级'
                this.rateTitle = '全校'
                this.people_option.xAxis[0].data = ['一年级', '二年级', '三年级', '四年级']
                this.use_time_option.xAxis[0].data = ['一年级', '二年级', '三年级', '四年级']
                this.use_number_option.xAxis[0].data = ['一年级', '二年级', '三年级', '四年级']
                this.grade_option.xAxis[0].data = ['一年级', '二年级', '三年级', '四年级']

                this.people_echarts()
                this.use_time_echarts()
                this.use_bumber_echarts()
                this.grade_echarts()
                this.getGradeData()

            }
        },
        // 选择班级
        chooseClass(value) {
            this.showOptions = false
            this.showClassOptions = false
            if (value !== this.classId) {
                this.classId = value
            }

            if(value!='班级') { // 如果选择了班级
                const classArr = ['一年级', '二年级', '三年级', '四年级']
                const a = classArr.indexOf(this.gradeTitle) + 1
                this.$router.push({
                    name: 'ListOfReports',
                    params: {
                        gradeName: a,
                        ft: this.time,
                        et: this.timeEnd,
                        className: value,
                        classList: this.classList
                    }
                })
            }else {

            }
        },
        fun_calendar() {
            this.show = true;
        },
        funTimeEnd() {
            this.showTimeEnd = true;
        },
        formatter(type, value) {
            if (type === 'year') {
                return `${value}年`;
            } else if (type === 'month') {
                return `${value}月`
            } else if(type === 'day') {
               return `${value}日`
            }
            return value;
        },
        timeSave(val) {
            this.time = val.getFullYear() + '-' + (val.getMonth() + 1) + '-' + val.getDate()
            this.minTimeEnd = new Date(this.time)
            this.show = false;

            let startDate = (new Date(this.time.replace(new RegExp("-","gm"),"/"))).getTime(); //得到毫秒数
            let endDate= (new Date(this.timeEnd.replace(new RegExp("-","gm"),"/"))).getTime();

            if( startDate > endDate) {
                Dialog.alert({
                    message: '请选择正确时间区间'
                }).then(() => {
                    this.$router.go(0);
                });
            }else {
                if(this.gradeTitle != '年级' && this.gradeTitle != '各年级') {
                    this.getClassData()
                }else {
                    this.getGradeData()
                }
            }
        },
        // 确认修改结束时间
        timeFunEnd(val) {
            this.timeEnd = val.getFullYear() + '-' + (val.getMonth() + 1) + '-' + val.getDate()
            this.showTimeEnd = false;
            if(this.gradeTitle != '年级' && this.gradeTitle != '各年级') {
                this.getClassData()
            }else {
                this.getGradeData()
            }
        },
        onCancel () {
            this.show = false;
            this.showTimeEnd = false;
        },

        people_echarts() {
            let myChart = echarts.init(document.getElementById('people'));

            myChart.setOption(this.people_option);

            myChart.showLoading();

            setTimeout(() => {
                myChart.hideLoading()
            }, 2000);

        },

        use_time_echarts() {
            let myChart = echarts.init(document.getElementById('use_time'));

            myChart.setOption(this.use_time_option);

            myChart.showLoading();

            setTimeout(() => {
                myChart.hideLoading()
            }, 2000);

        },


      grade_echarts(){
        let myChart = echarts.init(document.getElementById('grade'));

        myChart.setOption(this. grade_option);

        myChart.showLoading();

        setTimeout(() => {
          myChart.hideLoading()
        }, 2000);

      },
        use_bumber_echarts() {
            let myChart = echarts.init(document.getElementById('use_number'));

            myChart.setOption(this.use_number_option);

            myChart.showLoading();

            setTimeout(() => {
                myChart.hideLoading()
            }, 2000);

        },


    }
};
</script>

<style>
.van-circle__text {
    font-size: 34px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}

</style>

<style scoped>

.school_page {
    padding: 30px;
}

.content {
    background: #fff;
    border-radius: 20px;
    padding: 20px;
    /* padding-top: 36px; */
}

.school_top {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    position: relative;
}
.select_box {
    display: flex;
    margin-top: 36px;
}
.select {
    margin-right: 24px;
}
.select_time {
    display: flex;
    line-height: 54px;
}

.select_time img {
    margin-left: 10px;
    vertical-align: -4px;
}
.time_end {
    position: absolute;
    right: 0;
    top: 60px;
}
.grade {
    width: 166px;
    height: 54px;
    line-height: 54px;
    font-size: 36px;
    text-indent: 12px;
    color: #3f8ed4;
    border: 2px solid #3f8ed4;
    border-radius: 30px;
    background: url("../../assets/blue_select.png") no-repeat scroll right center transparent;
    background-position-x: 130px;
    background-size: 24px;
    letter-spacing: 0;
}
.class {
    width: 194px;
    background-position-x: 156px;
}
ul {
    position: absolute;
    z-index: 1008;
    background: #fff;
    width: 166px;
    margin-top: 10px;
    border: 2px solid #3f8ed4;
    border-radius: 10px;
    font-size: 36px;
}

li {
    height: 70px;
}

li a{
    height: 70px;
    line-height: 70px;
    width: 100%;
    display: inline-block;
    color: #3f8ed4;
    text-indent: 12px;
}

li a:hover,a:active {
    background: #3f8ed4;
    color: #fff;
}

.dividing_line {
    margin-top: 36px;
    line-height: 54px;
    color: #e6e6e6;
    display: inline-block;
    padding-left: 10px;
}

.time {
    font-size: 30px;
}

.calendar_icon img{
    width: 50px;
}

.title {
    display: inline-block;
    margin: 40px 0 50px;
}

.titleF {
    display: block;
}


.circle {
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #3f8ed4;
}

.progressbar {
    position: relative;
    margin: 40px 0;
    text-align: center;
}

.progressbar .title {
    text-align: left;
}

@media screen and (max-device-width: 320px) {
    .tips_box {
        top: 28%;
        left: 22%;
    }
}

.tips_box {
    position: absolute;
    top: 28%;
    left: 26%;
    border-radius: 50%;
    line-height: 90px;
    text-align: center;
    width: 90px;
    height: 90px;
    padding: 15px;
    background: #fff;
}

.tips {
    /* position: absolute; */
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: #7cd393;
    color: #fff;
    font-size: 32px;

}

.result {
    text-align: center;
    margin: 0px 0 80px;
}
</style>



// WEBPACK FOOTER //
// src/views/second/SchoolPage.vue